if (!customElements.get('piecework-circle-border')) {
  customElements.define(
    'piecework-circle-border',
    class PieceworkCircleBorder extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          y: this.querySelectorAll('.side-y'),
          x: this.querySelectorAll('.side-x'),
          countX: 1,
          countY: 1,
        };

        this.makeCircles();

        window.addEventListener('resize', () => {
          this.makeCircles();
        });
      }

      makeCircles() {
        const yCount = Math.ceil(this.elements.y[0].offsetWidth / 10);
        const xCount = Math.ceil(this.elements.x[0].offsetHeight / 10);

        this.elements.y.forEach((y) => {
          y.innerHTML = '';
          for (let i = 0; i < yCount; i++) {
            const circle = document.createElement('div');
            y.appendChild(circle);
          }
        });

        this.elements.x.forEach((x) => {
          x.innerHTML = '';
          for (let i = 0; i < xCount; i++) {
            const circle = document.createElement('div');
            x.appendChild(circle);
          }
        });
      }
    }
  );
}
